/**
 * Cliente das rotas publicas da API.
 *
 * A landing consome apenas `GET /plans` e `GET /condominiums`, ambas sem
 * autenticacao, por isso nao ha token nem cookie aqui.
 */
import { config } from './config.js';

async function request(path, { signal } = {}) {
  const response = await fetch(`${config.apiUrl}${path}`, {
    signal,
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    let message = `Falha na requisicao (${response.status})`;
    try {
      const body = await response.json();
      message = body?.error?.message ?? message;
    } catch {
      // Resposta sem corpo JSON: mantem a mensagem padrao.
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export const fetchPlans = (options) => request('/plans', options);

export function fetchCondominiums({ state, city, search, limit = 12, signal } = {}) {
  const params = new URLSearchParams();
  if (state) params.set('state', state);
  if (city) params.set('city', city);
  if (search) params.set('search', search);
  params.set('limit', String(limit));
  return request(`/condominiums?${params.toString()}`, { signal });
}

export default { fetchPlans, fetchCondominiums };
